import { Stack, Typography } from "@mui/material";
import { BaseIcon } from "../../shared/ui/BaseIcons";

type DeliveryRouteTaskContentTagProps = {
  isLoad: boolean;
};

const DeliveryRouteTaskContentTag = ({
  isLoad,
  ...props
}: DeliveryRouteTaskContentTagProps) => {
  const tagTextColor = isLoad ? "#52A48B" : "white";
  const tagBgColor = isLoad ? "white" : "#52A48B";

  return (
    <Stack
      px={1}
      width={"84px"}
      height={"32px"}
      border="2px solid #52A48B"
      bgcolor={tagBgColor}
      borderRadius={"18px"}
      direction={"row"}
      justifyContent="center"
      alignItems="center"
      fontSize={"14px"}
      {...props}
    >
      {isLoad ? (
        <BaseIcon
          name="arrowUp"
          htmlColor="#52A48B"
          sx={{ fontSize: "16px" }}
        />
      ) : (
        <BaseIcon
          name="arrowDown"
          htmlColor="white"
          sx={{ fontSize: "16px" }}
        />
      )}
      <Typography
        variant="body2"
        fontWeight={700}
        color={tagTextColor}
        textAlign="center"
        width="100%"
      >
        {isLoad ? "積込み" : "取卸し"}
      </Typography>
    </Stack>
  );
};

export type DeliveryRouteTaskContentTagsProps = {
  hasLoading: boolean;
  hasUnloading: boolean;
};

export const DeliveryRouteTaskContentTags = ({
  hasLoading,
  hasUnloading,
}: DeliveryRouteTaskContentTagsProps) => {
  return (
    <Stack spacing={1} direction="row">
      {hasLoading && <DeliveryRouteTaskContentTag isLoad={true} />}
      {hasUnloading && <DeliveryRouteTaskContentTag isLoad={false} />}
    </Stack>
  );
};
